var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgConnect28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9497 0.564972L27.435 9.05025L18.9497 17.5355L16.8284 15.4142L18.2426 14L18.9497 14.7071L24.6066 9.05025L18.9497 3.3934L13.2929 9.05025L14 9.75736L12.5858 11.1716L10.4645 9.05025L18.9497 0.564972ZM0.564972 18.9497L9.05025 27.435L17.5355 18.9497L15.4142 16.8284L14 18.2426L14.7071 18.9497L9.05025 24.6066L3.3934 18.9497L9.05025 13.2929L9.75736 14L11.1716 12.5858L9.05025 10.4645L0.564972 18.9497ZM18.2426 11.1716L16.8284 9.75736L9.75736 16.8284L11.1716 18.2426L18.2426 11.1716Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnect28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;